import React from 'react';
import { Card } from '../ui/Card';
import { TagIcon, PlusIcon } from 'lucide-react';
export function TagsTab({
  contact
}) {
  return <div data-id="element-458">
      <Card title="Manage Tags" data-id="element-459">
        <div className="flex flex-wrap gap-2 mb-4" data-id="element-460">
          {contact.tags.map((tag, index) => <span key={index} className="px-3 py-1.5 bg-blue-100 text-blue-800 rounded-full text-sm flex items-center gap-1" data-id="element-461">
              {tag}
              <button className="ml-1 text-blue-600 hover:text-blue-800" data-id="element-462">
                ×
              </button>
            </span>)}
        </div>
        <div className="mt-4" data-id="element-463">
          <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-464">
            Add New Tag
          </label>
          <div className="flex gap-2" data-id="element-465">
            <input type="text" className="flex-grow px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500" placeholder="Enter tag name..." data-id="element-466" />
            <button className="flex items-center gap-1 px-3 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors" data-id="element-467">
              <PlusIcon className="w-4 h-4" data-id="element-468" />
              <span data-id="element-469">Add</span>
            </button>
          </div>
        </div>
      </Card>
      <Card title="Common Tags" className="mt-4" data-id="element-470">
        <div className="flex flex-wrap gap-2" data-id="element-471">
          <button className="px-3 py-1.5 border border-gray-300 text-gray-700 rounded-full text-sm hover:bg-gray-100" data-id="element-472">
            VIP
          </button>
          <button className="px-3 py-1.5 border border-gray-300 text-gray-700 rounded-full text-sm hover:bg-gray-100" data-id="element-473">
            New Customer
          </button>
          <button className="px-3 py-1.5 border border-gray-300 text-gray-700 rounded-full text-sm hover:bg-gray-100" data-id="element-474">
            Premium
          </button>
          <button className="px-3 py-1.5 border border-gray-300 text-gray-700 rounded-full text-sm hover:bg-gray-100" data-id="element-475">
            Student
          </button>
          <button className="px-3 py-1.5 border border-gray-300 text-gray-700 rounded-full text-sm hover:bg-gray-100" data-id="element-476">
            Corporate
          </button>
        </div>
      </Card>
    </div>;
}